/**
 * Bonus copied Replacer View
 */

define(function(require, exports, module) {
    'use strict';

    const BaseReplacerView = require('common/base.replacer.view');
    const core = require('core');
    const config = require('config');
    const checkCounterClass = require('../../common/swiss-theme/checkConterClass/checkCounterClass');

    module.exports = BaseReplacerView.extend({

        tagName: 'span',

        subscribe: function() {
            this.listenTo(core, 'notification-bonusCopied:updated', this._countBonuses);
        },

        render: function() {
            this._countBonuses();

            return this;
        },

        _countBonuses: function() {
            const count = config.get('bonusCounter');
            const className = checkCounterClass.prototype.countClassName(count);
            const bigCount = checkCounterClass.prototype.bigCount;

            this.$el.html(this.tmpl('bonus.counter', {
                count,
                className,
                bigCount
            }));
        }

    }, {
        nameOfReplacers: [
            'BONUS_COPIED'
        ]
    });
});
